import React, { Component } from 'react';

// import './GT-Sectra-Fine-Medium.ttf';
import './App.css';

import words from './ulysses.json'
import images from './brooklyn.json'

import update from 'immutability-helper';

class Pair extends Component {
    render() {
        const addNbsp = (t) => {
            if (t.split(" ").length > 4) {
                const i = t.lastIndexOf(" ");
                return t.substr(0, i) + "\xa0" + t.substr(i+1);
            } else {
                return t;
            }
        }
        const s = {
            backgroundImage: "url(" + this.props.image_url + ")"
        }

        const lengthClass = this.props.word.split(" ").length < 7 ? "length-short" : "length-normal";

        if (!this.props.doneLoading) {
            return (
                <div className="pair loading">
                  <img alt="Loading.." src={this.props.image_url} className="loader" onLoad={this.props.onLoad}/>
                </div>
            )
        } else {
            return (
                <div className="pair">
                  <div className={"words " + lengthClass}>
                    <span>{addNbsp(this.props.word)}</span>
                  </div>
                  <div style={s} className="image partial">
                    &nbsp;
                  </div>
                </div>
            )
        }
    }
}

class App extends Component {
    constructor() {
        super();
        this.state = update(this.getRandom(), {
            doneLoading: {$set: false}
        });
    }

    randomize() {
        console.log("LK")
        this.setState(
            update(this.state,
                   {doneLoading: {$set: false},
                    $merge: this.getRandom()})
        );
    }

    getRandom() {
        var satisfied = false;
        var r;
        while (!satisfied) {
            r = {image_url: "/img/" + images[Math.floor(Math.random() * images.length)],
                 word: words[Math.floor(Math.random() * words.length)]}

            if (!this.state || r.image_url !== this.state.image_url || r.word !== this.state.word) {
                satisfied = true;
            }
        }
        return r;
    }

    render() {
        const onLoad = () => {
            console.log("Done loading image.");
            this.setState(update(this.state, {doneLoading: {$set: true}}))
        };
        return (
            <div className="App">
              <div className="topMenu">
                <a onClick={() => {this.randomize()}}>semiolog</a>
              </div>
              <Pair onLoad={onLoad} word={this.state.word}
                    image_url={this.state.image_url}
                    doneLoading={this.state.doneLoading} />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js